import React, {useState} from "react";
import {Formik} from "formik";
import {useNavigate} from "react-router-dom";

import AuthPartnerLayout from "../../../../components/AuthPartnerLayout";
import joinClassNames from "../../../../../../base/helpers/joinClassNames";
import {BUTTON_COLORS} from "../../../../../../base/components/Button/appearance";
import Button from "../../../../../../base/components/Button";
import {useService} from "../../../../../../base/hooks/useService";
import PartnersService from "../../../../../../services/PartnersService";
import ToasterService from "../../../../../../services/ToastService";
import {useLoading} from "../../../../../../base/hooks/useLoading";
import {AUTH_GROUP_LINKS} from "../../../../config";
import FormikTextarea from "../../../../../../base/components/FormikTextarea";
import {MAX_BIO_LENGTH} from "./constants";
import {validationSchema} from "./form";

import classes from "./index.module.scss";
import StorageService from "../../../../../../services/StorageService";
import {KEY_USER} from "../../../../../../base/constants/storage";
import classnames from "classnames";
import Icon from "../../../../../../base/components/Icon";
import UploadAvatarModal from "./UploadAvatarModal/UploadAvatarModal";

const initialValues = {
    file: [],
    bio: ""
}

const Step3 = () => {
    /**
     * @type {PartnersService}
     */
    const partnersService = useService(PartnersService);
    /**
     * @type {ToasterService}
     */
    /**
     * @type {StorageService}
     */
    const storage = useService(StorageService);
    const toastService = useService(ToasterService);
    const [isLoading, {registerPromise}] = useLoading();
    const currentPartner = storage.get(KEY_USER, { firstName: "", lastName: "" });
    const navigate = useNavigate();

    const [openUploadAvatar, updateOpenUploadAvatar] = useState();

    const onAddPersonalInfo = (values, formikHelpers) => {
        formikHelpers.setSubmitting(true);

        const model = {
            bio: values.bio,
            fileId: values.file[0].file.id,
        }

        registerPromise(partnersService.addPartnerPersonalInfo(model))
            .then(() => {
                //TODO: Temp solution, need correct redirect
                navigate(AUTH_GROUP_LINKS.EXTERNAL.AFTER_LOGIN);
            })
            .catch((error) => {
                toastService.error(error.message);
            })
            .finally(() => {
                formikHelpers.setSubmitting(false);
            })
    }

    const onSkip = () => {
        //TODO: Temp solution, need correct redirect
        navigate(AUTH_GROUP_LINKS.EXTERNAL.AFTER_LOGIN);
    }

    return(
        <AuthPartnerLayout>
            <div className="w-100 d-flex align-items-center justify-content-center">
                <div className="partner-step-layout">
                    <div>
                        <h1 className="partner-step-title">
                            <span className="me-3">1
                                <span className="partner-text-grey font-size-16 me-2">/2</span>
                            </span>
                            Tell us a bit about yourself
                        </h1>
                    </div>
                    <p className="partner-text-grey font-size-18 mt-2 mb-0">
                        Make a great first impression! Add your profile picture and bio so clients can get to know you better.
                    </p>
                    <div className="mt-4-5">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            validateOnChange
                            onSubmit={(values, formikHelpers) => onAddPersonalInfo(values, formikHelpers)}
                            enableReinitialize
                        >
                            {({handleSubmit, values, setFieldValue, setFieldTouched, isSubmitting, isValid, dirty}) => {
                                return (
                                    <form
                                        className={joinClassNames("form-horizontal", isSubmitting && "pointer-events-none")}
                                        onSubmit={handleSubmit}
                                    >
                                        <div className="mt-4-5 mb-3 d-flex align-items-center justify-content-center flex-column w-100 position-relative">
                                            <div className={classnames(
                                                classes.AvatarContainer,
                                                "d-flex align-items-center justify-content-center position-relative"
                                            )}>
                                                {values?.file[0]?.file?.link ?
                                                    <img alt="avatar" src={values?.file[0]?.file?.link} className={classes.AvatarContainer} />
                                                    :
                                                    <div className="w-100 d-flex align-items-center justify-content-center">
                                                    {currentPartner?.firstName?.charAt(0)}{currentPartner?.lastName?.charAt(0)}
                                                </div>}
                                                <div className={classnames(classes.UploadButton, "position-absolute")}>
                                                    <Icon
                                                        onClick={() => {
                                                            if (values?.file[0]?.file?.link) {
                                                                setFieldValue("file", []);
                                                            }
                                                            updateOpenUploadAvatar(true)
                                                        }}
                                                        icon="partnerUploadAvatar"
                                                        className="cursor-pointer"
                                                        width={48}
                                                        height={48}
                                                    />
                                                </div>
                                            </div>
                                            {values?.file[0]?.file?.link &&
                                            <div
                                                className="d-flex align-items-center cursor-pointer partner-text-red font-weight-semibold mt-3"
                                                onClick={
                                                    () => {
                                                        setFieldValue("file", []);
                                                    }
                                                }>
                                                <Icon icon="partnerTrash"
                                                      width={20}
                                                      height={20}
                                                      className="me-2"
                                                />
                                                <div>
                                                    Remove avatar
                                                </div>
                                            </div>
                                            }
                                        </div>
                                        <UploadAvatarModal
                                            isOpen={openUploadAvatar}
                                            updateIsOpen={updateOpenUploadAvatar}
                                            file={values?.file}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                        />
                                        <FormikTextarea
                                            id="bio"
                                            name="bio"
                                            label="Brief bio"
                                            placeholder="e. g. I have over 5 years of experience in the nutrition. I help adults...."
                                            rows="3"
                                            type="textarea"
                                            maxLength={MAX_BIO_LENGTH}
                                        />
                                        <div className="d-flex gap-3 mt-4-5 mb-5">
                                            <Button
                                                color={BUTTON_COLORS.secondary}
                                                type="button"
                                                onClick={() => onSkip()}
                                                className="w-50 partner-secondary"
                                            >
                                                Skip for now
                                            </Button>
                                            <Button
                                                color={BUTTON_COLORS.primary}
                                                type="submit"
                                                loading={isLoading || isSubmitting}
                                                className="sign-up-submit w-50"
                                                disabled={
                                                    isLoading ||
                                                    !(isValid && dirty)
                                                }
                                            >
                                                Continue
                                            </Button>
                                        </div>
                                    </form>
                                )
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        </AuthPartnerLayout>
    )
}

export default Step3